import { useState } from 'react';
import prpo from "./Image/logo1.png"
import cmf from "./Image/logo2.png"

function App() {
  const [currentPage, setCurrentPage] = useState('landing');

  const styles = {
    container: {
      minHeight: '100vh',
      background: '#f8fafc',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },
    mainContent: {
      maxWidth: '1024px',
      width: '100%'
    },
    header: {
      textAlign: 'center',
      marginBottom: '3rem'
    },
    title: {
      fontSize: 'clamp(2.5rem, 7vw, 4rem)',
      fontWeight: 'bold',
      color: '#1e293b',
      marginBottom: '1rem'
    },
    subtitle: {
      fontSize: 'clamp(1.25rem, 3vw, 1.5rem)',
      color: '#475569',
      marginBottom: '0.5rem'
    },
    description: {
      fontSize: '1.125rem',
      color: '#64748b'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '2rem'
    },
    card: {
      background: 'white',
      borderRadius: '0.75rem',
      padding: '2rem',
      boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
      border: '1px solid #e2e8f0',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      textAlign: 'center'
    },
    cardHover: {
      transform: 'translateY(-4px)',
      boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)'
    },
    icon: {
      fontSize: '4rem',
      marginBottom: '1rem',
      transition: 'transform 0.3s ease'
    },
    cardTitle: {
      fontSize: '2rem',
      fontWeight: 'bold',
      color: '#1e293b',
      marginBottom: '1rem'
    },
    cardSubtitle: {
      fontSize: '1.125rem',
      color: '#475569',
      marginBottom: '0.5rem'
    },
    cardDescription: {
      fontSize: '0.875rem',
      color: '#64748b'
    },
    cardAction: {
      marginTop: '1.5rem',
      fontSize: '1.125rem',
      fontWeight: '600',
      transition: 'color 0.2s ease'
    },
    footer: {
      textAlign: 'center',
      marginTop: '3rem',
      color: '#94a3b8',
      fontSize: '0.875rem'
    },
    pageContainer: {
      background: 'white',
      borderRadius: '1rem',
      boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)',
      padding: '3rem',
      border: '1px solid #e2e8f0',
      maxWidth: '768px',
      margin: '0 auto'
    },
    featureBox: {
      borderRadius: '0.75rem',
      padding: '1.5rem',
      marginBottom: '2rem',
      border: '1px solid'
    },
    featureTitle: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginBottom: '1rem'
    },
    featureList: {
      textAlign: 'left',
      color: '#334155',
      lineHeight: '2'
    },
    backButton: {
      background: '#3b82f6',
      color: 'white',
      padding: '1rem 2rem',
      borderRadius: '0.5rem',
      fontSize: '1.125rem',
      fontWeight: '600',
      border: 'none',
      cursor: 'pointer',
      boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
      transition: 'all 0.2s ease'
    }
  };

  const [hoveredCard, setHoveredCard] = useState(null);

  // Landing Page
  if (currentPage === 'landing') {
    return (
      <div style={styles.container}>
        <div style={styles.mainContent}>
          <div style={styles.header}>
            <h1 style={styles.title}>Web Management System</h1>
            <p style={styles.subtitle}>Select Document Type</p>
            <p style={styles.description}>Choose which system you want to access</p>
          </div>

          <div style={styles.grid}>
            {/* PRPO Card */}
            <div
              style={{
                ...styles.card,
                ...(hoveredCard === 'prpo' ? styles.cardHover : {})
              }}
              onClick={() => {
                window.location.href = "http://114.29.239.77:5253/";
              }}
              onMouseEnter={() => setHoveredCard('prpo')}
              onMouseLeave={() => setHoveredCard(null)}
            >

              <img
                src={prpo}
                alt="PRPO Logo"
                style={{
                  width: '120px',
                  height: '120px',
                  objectFit: 'contain',
                  marginBottom: '1rem',
                  transition: 'transform 0.3s ease',
                  transform: hoveredCard === 'prpo' ? 'scale(1.1)' : 'scale(1)'
                }}
              />
              <h2 style={styles.cardTitle}>PRPO</h2>
              <p style={styles.cardSubtitle}>Purchase Request & Purchase Order</p>
              <p style={styles.cardDescription}>
                Manage procurement documents, requests, and purchase orders
              </p>
              <div style={{
                ...styles.cardAction,
                color: hoveredCard === 'prpo' ? '#2563eb' : '#3b82f6'
              }}>
                Access PRPO →
              </div>
            </div>

            {/* CMF Card */}
            <div
              style={{
                ...styles.card,
                ...(hoveredCard === 'prpo' ? styles.cardHover : {})
              }}
              onClick={() => {
                window.location.href = "https://cmf-bpdc.onrender.com/";
              }}
              onMouseEnter={() => setHoveredCard('prpo')}
              onMouseLeave={() => setHoveredCard(null)}
            >

              <img
                src={cmf}
                alt="CMF Logo"
                style={{
                  width: '120px',
                  height: '120px',
                  objectFit: 'contain',
                  marginBottom: '1rem',
                  transition: 'transform 0.3s ease',
                  transform: hoveredCard === 'cmf' ? 'scale(1.1)' : 'scale(1)'
                }}
              />
              <h2 style={styles.cardTitle}>CMF</h2>
              <p style={styles.cardSubtitle}>Customer Master File</p>
              <p style={styles.cardDescription}>
                View and manage customer information and records
              </p>
              <div style={{
                ...styles.cardAction,
                color: hoveredCard === 'cmf' ? '#059669' : '#10b981'
              }}>
                Access CMF →
              </div>
            </div>
          </div>

          <div style={styles.footer}>
            <p>Secure Document Management System ✨</p>
            <p style={{ marginTop: '0.5rem' }}>Powered By: <strong>QS I.T SERVICES</strong></p>
            <p style={{ fontSize: '0.75rem', marginTop: '0.25rem', color: '#94a3b8' }}>
              © 2026 All rights reserved
            </p>
          </div>

        </div>
      </div>
    );
  }

  // Page 1 - PRPO
  if (currentPage === 'page1') {
    return (
      <div style={styles.container}>
        <div style={styles.pageContainer}>
          <div style={{ textAlign: 'center' }}>
            <img
              src={prpo}
              alt="PRPO Logo"
              style={{
                width: '250px',
                height: '250px',
                objectFit: 'contain',
                marginBottom: '1.5rem'
              }}
            />
            <h1 style={{ ...styles.title, fontSize: '2.5rem' }}>PRPO System</h1>
            <p style={{ ...styles.subtitle, fontSize: '1.25rem', marginBottom: '2rem' }}>
              Purchase Request & Purchase Order Management
            </p>

            <div style={{
              ...styles.featureBox,
              background: '#eff6ff',
              borderColor: '#dbeafe'
            }}>
              <h3 style={{ ...styles.featureTitle, color: '#1e3a8a' }}>
                Available Functions:
              </h3>
              <ul style={styles.featureList}>
                <li>✅ Create Purchase Requests</li>
                <li>✅ Generate Purchase Orders</li>
                <li>✅ Track Document Status</li>
                <li>✅ Approval Workflow</li>
                <li>✅ Supplier Management</li>
                <li>✅ Budget Monitoring</li>
              </ul>
            </div>

            <button
              style={styles.backButton}
              onClick={() => setCurrentPage('landing')}
              onMouseEnter={(e) => e.target.style.background = '#2563eb'}
              onMouseLeave={(e) => e.target.style.background = '#3b82f6'}
            >
              ← Back to Main Menu
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Page 2 - CMF
  if (currentPage === 'page2') {
    return (
      <div style={styles.container}>
        <div style={styles.pageContainer}>
          <div style={{ textAlign: 'center' }}>
            <img
              src={cmf}
              alt="CMF Logo"
              style={{
                width: '250px',
                height: '250px',
                objectFit: 'contain',
                marginBottom: '1.5rem'
              }}
            />
            <h1 style={{ ...styles.title, fontSize: '2.5rem' }}>CMF System</h1>
            <p style={{ ...styles.subtitle, fontSize: '1.25rem', marginBottom: '2rem' }}>
              Customer Master File Management
            </p>

            <div style={{
              ...styles.featureBox,
              background: '#ecfdf5',
              borderColor: '#d1fae5'
            }}>
              <h3 style={{ ...styles.featureTitle, color: '#065f46' }}>
                Available Functions:
              </h3>
              <ul style={styles.featureList}>
                <li>🌟 View Customer Records</li>
                <li>🌟 Add New Customers</li>
                <li>🌟 Update Customer Info</li>
                <li>🌟 Transaction History</li>
                <li>🌟 Contact Management</li>
                <li>🌟 Search & Filter</li>
              </ul>
            </div>

            <button
              style={{ ...styles.backButton, background: '#10b981' }}
              onClick={() => setCurrentPage('landing')}
              onMouseEnter={(e) => e.target.style.background = '#059669'}
              onMouseLeave={(e) => e.target.style.background = '#10b981'}
            >
              ← Back to Main Menu
            </button>
          </div>
        </div>

      </div>
    );
  }
}

export default App;